module.exports = __webpack_public_path__ + "img/win-s2-icon3.d8fd1c91.svg";